export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11442.8c3b5f64.jpg";